import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const createRun = (payload) =>
  axios.post(`${API}/test-runs`, payload).then((r) => r.data);

export const getRun = (id) =>
  axios.get(`${API}/test-runs/${id}`).then((r) => r.data);

export const listRuns = () =>
  axios.get(`${API}/test-runs`).then((r) => r.data);

export const deleteRun = (id) =>
  axios.delete(`${API}/test-runs/${id}`).then((r) => r.data);

export const exportUrl = (id) => `${API}/test-runs/${id}/export`;

export const listProfiles = () =>
  axios.get(`${API}/auth-profiles`).then((r) => r.data);

export const createProfile = (payload) =>
  axios.post(`${API}/auth-profiles`, payload).then((r) => r.data);

export const deleteProfile = (id) =>
  axios.delete(`${API}/auth-profiles/${id}`).then((r) => r.data);

export const getLastPreset = (source) =>
  axios.get(`${API}/last-preset`, { params: { source } }).then((r) => r.data);
